import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var UserLinear = function UserLinear(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 13.28C1.75 10.842 5.917 9.5 8 9.5c2.084 0 6.25 1.341 6.25 3.78v1.22H1.75v-1.22zM11.5 5c0 1.937-1.563 3.5-3.5 3.5A3.495 3.495 0 014.5 5c0-1.937 1.564-3.5 3.5-3.5 1.937 0 3.5 1.563 3.5 3.5z",
    fill: "currentColor"
  }));
};
export default UserLinear;